<div
    class="flex flex-col px-10 py-4 border-2 border-gray-900/10 rounded-md"
    [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'"
>
    <div class="text-lg font-semibold my-1">
        {{ title() }}
        @if (optional()) {
            <span class="italic text-xs font-light">neobavezno</span>
        }
    </div>
    <div class="valben-calendar-shell mt-3 w-80 max-w-full overflow-hidden rounded-xl border border-slate-200 bg-white">
        <mat-calendar
            class="valben-admin-calendar w-full"
            [selected]="date ?? null"
            [startAt]="date ?? null"
            [minDate]="minDate() ?? null"
            [maxDate]="maxDate() ?? null"
            (selectedChange)="onSelect($event)" />
        <div class="flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-4 py-3">
            @if (showTodayButton() && todayInRange()) {
                <button type="button" class="valben-calendar-action valben-calendar-action--primary" (click)="setToday()" aria-label="Danas">Danas</button>
            }
            <button type="button" class="valben-calendar-action" (click)="onClear()" aria-label="Očisti datum">Očisti</button>
        </div>
    </div>
</div>
